(function(){
  'use strict';

  // Note: The location lookup functionality can be found in the main.js.
  // See: squiz.fn.initLocationLookup()
  // Located here: "src/modules/_global/js/global.js"


  // Add the listeners for the outage checker component
  let outageCheckerForm = document.getElementsByClassName('js-outage-checker-form');

  if (outageCheckerForm.length !== 0) {
    outageCheckerForm = outageCheckerForm[0];
    outageCheckerForm.addEventListener('submit', onOutageCheckerSubmit);
  }

  /**
   * Hijack the outage checker form submission for some basic validation
   *
   * @param {Submission Event} evt Event that triggered the form submission
   *
   * @returns void
   */
  function onOutageCheckerSubmit(evt) {
    const hiddenInputsArray = [
      document.getElementsByName('suburb')[0],
      document.getElementsByName('postcode')[0],
      document.getElementsByName('lat')[0],
      document.getElementsByName('lng')[0]
    ];
    let validationPassed = true;

    // Check that the hidden fields are all populated
    for (var i = 0, j = hiddenInputsArray.length; i < j; ++i) {
      if (hiddenInputsArray[i].value === "") {
        validationPassed = false;
      }
    }

    // Block the form submission if any of the hidden fields are empty
    if (!validationPassed) {
      evt.preventDefault();
    }
  }
}());